import axios from "axios";
//import store from "@/store/index";
//axios.defaults.baseURL = "https://dreamvision.jp/toyota_coniq_ride"; //バックエンド側のIPとポート
//axios.defaults.baseURL = "https://dreamvision.jp/mapTest";
//axios.defaults.baseURL = "http://192.168.0.139/toyota_coniq_ride";
//axios.defaults.baseURL = "http://localhost/toyota_coniq_ride";
//axios.defaults.baseURL = "http://localhost/toyota_coniq_ride_kiyama";
axios.defaults.baseURL = "https://dreamvision.jp/rakunoru_kiyama/yoyaku";
async function putMobilityData(formdata) {
  return await axios
    .post("/api/putMobilityData.php", formdata)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getMobilityData() {
  return await axios
    .post("/api/getMobilityData.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function postRequestData(formdata) {
  return await axios
    .post("/api/postRequestData.php", formdata)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getRequestData(formdata) {
  return await axios
    .post("/api/getRequestData.php", formdata)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function putRequestData(formdata) {
  return await axios
    .post("/api/putRequestData.php", formdata)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function putRequestDataNo(formdata) {
  return await axios
    .post("/api/putRequestDataNo.php", formdata)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function putRequestDataArrival(formdata) {
  return await axios
    .post("/api/putRequestDataArrival.php", formdata)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getRequestDataQuery(query) {
  return await axios
    .post("/api/getRequestDataQuery.php" + query)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function cancelRequest(id) {
  return await axios
    .post("/api/cancelRequest.php?id=" + id)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getBusStopList(id) {
  return await axios
    .post("/api/getBusStopList.php?id=" + id)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function setBreak(id, boolean) {
  return await axios
    .post("/api/setBreak.php?id=" + id + "&break=" + boolean)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getBusStopSetId() {
  return await axios
    .post("/api/getBusStopSetId.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function postGettingOnAndOff(formdata) {
  return await axios
    .post("/api/postGettingOnAndOff.php", formdata)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function postMobilityOperationData(formdata) {
  return await axios
    .post("/api/postMobilityOperationData.php", formdata)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getOperation() {
  return await axios
    .get("/api/getOperation.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getOutOfService() {
  return await axios
    .get("/api/getOutOfService.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getSetting() {
  return await axios
    .get("/api/getSetting.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function postMail(txt, mail) {
  return await axios
    .post("/api/postMail.php?mail=" + mail + "&txt=" + txt)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function postDeviceStatus(formdata) {
  return await axios
    .post("/api/postDeviceStatus.php", formdata)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function postOrders(
  phone_number,
  passenger_name,
  location_name,
  location_lat,
  location_lng,
  destination_name,
  destination_lat,
  destination_lng,
  reserve_at,
  message
) {
  return await axios
    .post(
      "/api/postOrders.php?phone_number=" +
        phone_number +
        "&passenger_name=" +
        passenger_name +
        "&location_name=" +
        location_name +
        "&location_lat=" +
        location_lat +
        "&location_lng=" +
        location_lng +
        "&destination_name=" +
        destination_name +
        "&destination_lat=" +
        destination_lat +
        "&destination_lng=" +
        destination_lng +
        "&reserve_at=" +
        reserve_at +
        "&message=" +
        message
    )
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getOrders(id) {
  return await axios
    .get("/api/getOrders.php?id=" + id)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function deleteOrders(id) {
  return await axios
    .get("/api/deleteOrders.php?id=" + id)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getCrews(number) {
  return await axios
    .get("/api/getCrews.php?number=" + number)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
export default {
  putMobilityData,
  getMobilityData,
  postRequestData,
  getRequestData,
  putRequestData,
  putRequestDataNo,
  putRequestDataArrival,
  getRequestDataQuery,
  cancelRequest,
  getBusStopList,
  setBreak,
  getBusStopSetId,
  postGettingOnAndOff,
  postMobilityOperationData,
  getOperation,
  getOutOfService,
  getSetting,
  postMail,
  postDeviceStatus,
  postOrders,
  getOrders,
  deleteOrders,
  getCrews,
};
